import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {
  IOrderSignerModel,
  signerStatusTranslationKeyMapper,
  signerVariantMapper,
} from '@dss-libs/portal/type/portal-types';
import { ButtonComponent, ChipComponent } from '@dss-libs/shared/ui/common-components';
import { InitialsPipe } from '@dss-libs/shared/ui/common-pipes';
import { SignerStatusBoxComponent } from '../signer-status-box/signer-status-box.component';

@Component({
  selector: 'dss-libs-feature-signer-card',
  imports: [ButtonComponent, SignerStatusBoxComponent, InitialsPipe, ChipComponent],
  templateUrl: './signer-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignerCardComponent {
  readonly signer = input.required<IOrderSignerModel>();
  readonly expiryDate = input.required<string>();
  readonly daysRemaining = input<number | null>(null);
  readonly sendingReminderForId = input<string | null>(null);
  readonly canSendReminder = input(true);
  readonly isLast = input(false);

  readonly sendReminder = output<string>();

  protected readonly signerVariantMapper = signerVariantMapper;
  protected readonly signerStatusTranslationKeyMapper = signerStatusTranslationKeyMapper;
}
